<template lang="pug">
#myAgency(v-loading="loading" element-loading-text="数据加载中")
  el-tabs(v-model="activeName" @tab-click="handleClick")
    el-tab-pane(label="我的审批" name="first")
    el-tab-pane(label="我的计划" name="second")
  .content(v-if="activeName==='first'")
    .header-midd
      search(ref="approveSearch"  @change="handleSearch")
    .midd
      el-table(ref="multipleTable" highlight-current-row size="small" border height="100%"
        :data="tableData")
        el-table-column(type="index" label="编号" align="center" width="60")
        el-table-column(label="状态"  sortable prop="status" width="80px" align="center" v-slot="{row}")
          span.flowStatus(:class="`type${row.status}`") {{statusName(row.status)}}
        el-table-column(label="流程类型" sortable align="center" prop="flowType" min-width="80px")
        el-table-column(label="标题" sortable prop="title" min-width="120px" v-slot="{row}")
          el-link(type="primary" @click="clickChange(row, 'edit')" v-if="row.status === 2")
            span(class="tabLinkSpan" :title='row.title') {{ row.title }}
          span(class="tabLinkSpan" :title='row.title' v-else) {{ row.title }}
        el-table-column(label="内容" prop="content" min-width="100px" show-overflow-tooltip)
        el-table-column(label="申请人" prop="flowInstanceOwnerName" min-width="100px")
        el-table-column(label="开始时间" prop="flowInstanceStartTime" min-width="100px" show-overflow-tooltip)
        el-table-column(label="当前审批人" align="center" prop="currentNodeAssigneeName" min-width="200px" show-overflow-tooltip)
        el-table-column(label="上个审批节点" align="center" prop="lastNodeName" min-width="200px" show-overflow-tooltip)
        el-table-column(label="操作" align="center" v-slot="{row}")
          //- el-button(type="text" @click.stop="flowAgree(row)") 通过
          //- el-button(type="text" @click.stop="clickChange(row)") 详情
          el-button(type="text" v-if="row.status === 2" @click.stop="clickChange(row, 'edit')") 审批
          el-button(type="text" @click.stop="flowReject(row)") 驳回
    .page
      el-pagination(:current-page.sync="page.pageNum"
        :page-size="page.pageSize"
        :layout="page.pageLayout"
        :total="page.totalCount"
        v-if="page.totalCount > 0"
        :page-sizes="[10, 20, 50, 100]"
        size="small"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange")
  .content(v-if="activeName==='second'")
    .header-midd
      el-form(ref="form" size="small" :model="taskform" inline)
        el-form-item( label="所属项目")
          el-select(v-model="taskform.prjId" size="small" clearable filterable )
            el-option( v-for="item in taskPrjListList" :key="item.prjId" :label="item.prjName" :value="item.prjId")
        el-form-item(label="计划名称")
          el-input(v-model="taskform.taskName" size="small" placeholder="请输入计划名称" clearable filterable)
        el-form-item
          el-button(size="small" type="primary" @click="searchChange") 查 询
          el-button(size="small" type="primary" plain @click="resetForm") 重 置
    .midd
      el-table(ref="multipleTable" border highlight-current-row size="small" height="100%"
        :data="taskData")
        el-table-column(label="编号" type="index" width="60")
        el-table-column(label="所属项目" prop="prjName")
        el-table-column(label="计划名称" prop="taskName")
        el-table-column(label="计划类型" prop="taskTypeName")
        el-table-column(label="状态" prop="statusName")
        el-table-column(label="责任人" prop="taskUserName" min-width="200px" show-overflow-tooltip)
        el-table-column(label="时间" prop="time")
    .page
      el-pagination(:current-page.sync="page.pageNum"
        :page-size="page.pageSize"
        :layout="page.pageLayout"
        :total="page.totalCount"
        v-if="page.totalCount > 0"
        :page-sizes="[10, 20, 50, 100]"
        size="small"
        background
        @size-change="handleSizeTaskChange"
        @current-change="handleCurrentTaskChange")
  el-dialog(title="驳回" :visible.sync="flowRejectDialog" width="30%" :before-close="closeFlowRejectDialog")
    el-form(ref="form" size="small")
      el-form-item( label="审批意见")
        el-input(v-model="comment" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" style="width: 100%"
          maxlength="200" show-word-limit placeholder="请输入审批意见")
    span(slot="footer")
      el-button(@click="closeFlowRejectDialog" size="small") 取 消
      el-button(type="primary" @click="rejectCheckFlow" size="small") 确 定
</template>

<script>
import search from "@/CommonDP/pages/mainMg/approval/config/search.vue";
import flowService from "@/CommonDP/service/flow-service";
import approvalService from "@/CommonDP/service/approve-service";
import { mapState } from "vuex";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
export default {
  name: "MyAgency",
  components: { search },
  data () {
    return {
      activeName: 'first',
      tableData: [],
      loading: false,
      page: {
        pageLayout: "total, sizes, prev, pager, next, jumper",
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      taskform: {
        prjId: "",
        taskName: ""
      },
      taskPrjListList: [],
      taskData: [],
      flowRejectDialog: false,
      comment: "", // 审批意见
      flowInstanceNodeId: '',
      viewMode: 1, // 新增0 审批1 查看2
      statusName: getStatusName
    };
  },
  computed: {
    searchFormParams() {
      return this.$refs.approveSearch.getForm();
    },
    taskformParams() {
      return {
        ...this.taskform,
        enterpriseId: this.enterpriseId,
        taskType: ""
      };
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted () {
    this.page.pageNum = 1;
    this.getPendList();
  },
  methods: {
    async handleClick(tab, event) {
      this.page.pageNum = 1;
      if (this.activeName === "first") {
        await this.$nextTick();
        this.$refs.approveSearch.resetForm();
        this.getPendList();
      } else {
        this.taskform.prjId = "";
        this.taskform.taskName = "";
        this.getTaskPrjList();
        this.getTaskList();
      }
    },
    handleSearch(form) {
      this.page.pageNum = 1;
      this.getPendList();
    },
    async getPendList() {
      const { page: { pageNum, pageSize }} = this;
      this.loading = true;
      const { data, pageIndex, totalCount } = await flowService.myProcessing(this.searchFormParams, pageNum, pageSize);
      this.tableData = data;
      this.page.pageNum = pageIndex;
      this.loading = false;
      this.page.totalCount = totalCount;
    },
    updateTable() {
      this.getPendList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPendList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getPendList();
    },
    // 通过操作
    flowAgree(row) {
      this.$confirm(`将对该流程进行通过操作，是否确认？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(async () => {
        if (row.flowKey === "check") {
          const res = await flowService.getBusinessForm(row.flowInstanceId);
          const list = res.data.fileInfoList.filter(ele => ele.uploadType !== 0).filter(ele => ele.isRead === 0);
          if (list.length) return this.$warn("有文件未打开查看，请打开查看文件！");
        } else {
          const params = {
            flowInstanceNodeId: row.currentNodeId
          };
          await flowService.agree(params);
          this.$success("通过流程成功！");
          this.getPendList();
        }
      }).catch(() => {
        // this.$message.info("已取消删除");
      });
    },
    // 审批
    async clickChange(row, approveType) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", startMode } = row;
      const data = { currentVersionId, flowInstanceId, flowKey, approveType, businessId, enterpriseId: this.enterpriseId, isProject: this.isProject };
      // 新窗口打开
      if (startMode === "stdNew") {
        const routeUrl = this.$router.resolve({ path: "/examine-new", query: data });
        window.open(routeUrl.href, "_blank");
      } else {
        await openFlow(data);
        this.getPendList();
      }
    },
    // 驳回按钮
    async flowReject(row) {
      this.flowInstanceNodeId = row.currentNodeId;
      this.comment = "";
      this.flowRejectDialog = true;
    },
    closeFlowRejectDialog() {
      this.flowRejectDialog = false;
    },
    // 驳回
    async rejectCheckFlow() {
      if (this.comment === "") return this.$warn("请输入审批意见！");
      const params = {
        comment: this.comment,
        flowInstanceNodeId: this.flowInstanceNodeId
      };
      await flowService.rejectNodeFlow(params);
      this.$success("驳回流程成功！");
      this.flowRejectDialog = false;
      this.getPendList();
    },

    handleSizeTaskChange(val) {
      this.page.pageSize = val;
      this.getTaskList();
    },
    handleCurrentTaskChange(val) {
      this.page.pageNum = val;
      this.getTaskList();
    },
    // 计划项目
    async getTaskPrjList() {
      const res = await approvalService.queryTaskPrjList(this.enterpriseId);
      this.taskPrjListList = res.data;
    },
    async getTaskList() {
      const { page: { pageNum, pageSize }} = this;
      this.loading = true;
      const { data, pageIndex, totalCount } = await approvalService.queryMyCurrentApproveListTask(this.taskformParams, pageSize, pageNum);
      this.taskData = data;
      this.loading = false;
      this.page.pageNum = pageIndex;
      this.page.totalCount = totalCount;
    },
    // 我的计划查询
    searchChange() {
      this.page.pageNum = 1;
      this.getTaskList();
    },
    // 重置
    resetForm() {
      this.taskform.prjId = "";
      this.taskform.taskName = "";
      this.page.pageNum = 1;
      this.getTaskList();
    }
  }
};
</script>

<style lang="scss" scoped>
#myAgency {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 var(--big-space);
  display: flex;
  flex-direction: column;
  .el-tabs{
    padding-top: var(--small-space);
  }
  .content {
    height: 1px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}

.midd {
  flex: 1 1;
  overflow: hidden;
}

.page {
  margin: var(--middle-space) 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
}
.type1,.type4{
  border: 1px solid #10A667;
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}

.type2 {
  border: 1px solid #FF7A00;
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}

.type3 {
  border: 1px solid #60656B;
  background: rgba(96, 101, 107, 0.10);
  color: #60656B;
}

.type8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}

.type9 {
  border: 1px solid #2F8BF8;
  background: rgba(47, 139, 248, 0.10);
  color: #2F8BF8
}

.type0 {
  border: 1px solid #FF4A4A;
  background: rgba(255, 74, 74, 0.10);
  color: #FF4A4A;
}
</style>
